import ko from 'knockout';
import _ from 'lodash';

export function filterColumnSupportsListValues(filter, columns) {

    if (_.isNullOrUndefined(filter) || _.isNullOrUndefined(filter.column))
        return false;

    var columnId = ko.isObservable(filter.column.columnId) ? filter.column.columnId() : filter.column.columnId;

    //If columnId matches any that support list values, return true
    if (!_.isNullOrUndefined(_.find(columns, function (col) { return col.columnId === columnId; })))
        return true;

    //false...
    return false;
}
